import styled from 'styled-components';

import {
  fontSize,
  fontWeight,
  colorUsage,
  getSpacing,
  letterSpacing,
  lineHeight,
} from 'stylesheetB2c';

export const IconContainer = styled.div`
  font-size: ${fontSize.giant};
  line-height: ${getSpacing(0)};
  margin-bottom: ${getSpacing(3)};
`;
IconContainer.displayName = 'IconContainer';

export const SvgIconContainer = styled.div`
  font-size: ${fontSize.giant};
  line-height: ${getSpacing(0)};
  margin-bottom: ${getSpacing(4)};
`;
IconContainer.displayName = 'IconContainer';

export const Title = styled.div`
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.small};
  margin-top: ${getSpacing(2)};
  margin-bottom: ${getSpacing(1)};
  letter-spacing: ${letterSpacing.medium};
  line-height: ${lineHeight.small};
  text-align: center;
  color: ${colorUsage.whiteText};
`;
Title.displayName = 'Title';

export const Description = styled.div`
  font-size: ${fontSize.XXXSmall};
  font-weight: ${fontWeight.light};
  color: ${colorUsage.whiteText};
  line-height: ${lineHeight.XXSmall};
  text-align: center;
  letter-spacing: ${letterSpacing.medium};
  white-space: pre-line;

  :not(:last-child) {
    margin-bottom: ${getSpacing(6)};
  }
`;
Description.displayName = 'Description';
